/* =========================================================================
   NUTROVATE collection page
   Sort submits natively, quick add goes through the public Cart AJAX API,
   and the cart bubble is updated with Horizon's own hooks so the header
   count stays right without either side knowing about the other.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__nvCollectionInit) return;
  window.__nvCollectionInit = true;

  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var CART_ADD = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  var CART_URL = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';

  var toastEl, toastT;
  function toast(msg, link) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pd-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = link
      ? msg + ' <a href="' + CART_URL + '" style="color:#E0E721;text-decoration:underline;text-underline-offset:3px">View cart</a>'
      : msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  function syncCartUI(cart) {
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (n !== null) {
      $$('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', n === 0); });
      $$('[ref="cartBubbleCount"],[data-nv-cart-count]').forEach(function (el) {
        el.textContent = n > 99 ? '99+' : String(n);
        el.classList.toggle('is-on', n > 0);
        el.classList.toggle('hidden', n === 0);
      });
    }
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart, source: 'nv-collection' } }));
    });
  }

  function boot() {
    /* Sort. The select is inside a GET form, so this is only a convenience
       for pointer users; the form still works with JavaScript off. */
    $$('[data-nv-sort]').forEach(function (sel) {
      if (sel.dataset.nvBound) return;
      sel.dataset.nvBound = '1';
      sel.addEventListener('change', function () {
        if (sel.form) sel.form.submit();
      });
    });

    /* Quick add. Single variant products only, which is the whole range, so
       there is never a variant choice hiding behind this button. */
    $$('[data-nv-add]').forEach(function (btn) {
      if (btn.dataset.nvBound) return;
      btn.dataset.nvBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-nv-add');
        var label = btn.getAttribute('data-nv-label') || 'Item';
        if (!id) { toast('This one is not available yet'); return; }
        var restore = btn.innerHTML;
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Adding...';
        fetch(CART_ADD, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            syncCartUI(cart);
            if (!window.__nvCartDrawer) toast(label + ' added', true);
          })
          .catch(function (err) { toast(err.message || 'Something went wrong'); })
          .finally(function () {
            btn.removeAttribute('aria-disabled');
            btn.innerHTML = restore;
          });
      });
    });

    var els = $$('.nv-rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
